import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import JsonapiClient from '@holidayextras/jsonapi-client';
import StatusBar from '../../containers/status-bar';
import { setStatusBar } from '../../containers/status-bar/actions';
import InvitedTable from '../../components/invited-table';

import { authService } from '../../utils/auth-service';


const pStyle = {
  textAlign: 'center',
};

const pageStyle = {
  marginTop: 50,
};

class CampaignManage extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    routeParams: PropTypes.object.isRequired,
  };

  constructor() {
    super();

    this.state = {
      campaign: null,
    };

    this.client = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  getProfile = () => {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem('profile');
    return profile ? JSON.parse(localStorage.profile) : {};
  }

  componentDidMount = () => {
    const campaignId = this.props.routeParams.id;
    this.client.get('campaigns', campaignId, { include: ['members', 'pendingInvitations'] })
      .then(newCampaign => {
        this.setState({
          campaign: newCampaign.toJSONTree(),
        });
      });
  }

  goToCampaign = () => {
    const campaignId = this.props.routeParams.id;
    const { campaign } = this.state;

    const isACR = campaign.campaignType === 'ACR';
    this.context.router.push(`/${isACR ? 'acr-' : ''}campaign/${campaignId}`);
  }

  render() {
    const { campaign } = this.state;

    return (
      <div className="page">

        <div className="page-content">
          <div className="grid">

            <div style={pageStyle}>
              <StatusBar />
              <h1 style={pStyle}>Manage people on your campaign</h1>

              { campaign &&
                <div>
                  <br />
                  <h2 style={pStyle}>{campaign.name}</h2>
                  <br />
                  <InvitedTable campaign={campaign} />
                </div>
              }

              <div style={pStyle}>
                <button
                  className="large rose wide" onClick={this.goToCampaign}
                >
                  <p>Take me back to my campaign</p>
                </button>
              </div>

            </div>

          </div>
        </div>
      </div>
    );
  }
}

CampaignManage.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  currentUser: state.userData.get('currentUser'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetStatusBar: (message, colour) =>
      dispatch(setStatusBar(message, colour)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignManage);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-manage/index.js
 **/